// @flow
import { Checkbox, Form, Input, Password } from "views/components/common/Form";
import { ErrorMessage } from "views/components/common/ErrorMessage";
import {
	Label,
	Wrapper,
} from "../../../mobile/components/LoginPassword/LoginPassword.styles";
import { Link, Redirect, Route, Switch } from "react-router-dom";
import { LoginButton } from "views/components/LoginButton";
import { NavButtons } from "views/components/common/Buttons";
import { Onboarding } from "views/desktop/components/Welcome";
import { PasswordLegend } from "../../../mobile/components/cards/PasswordLegend.jsx";
import { PasswordLegendNormal } from "../../../mobile/components/cards/PasswordLegendNormal.jsx";
import { Spacer } from "views/components/common/Spacer";
import { Steps } from "antd";
import { validateEmail } from "lib/forms";
import PasswordInput from "../../../mobile/components/LoginPassword/PasswordInput";
import React, { useEffect, useGlobal, useState } from "reactn";
import SignUpProvider from "views/components/Register";
import TextInput from "../../../mobile/components/LoginPassword/TextInput";
import styled from "styled-components";

const { Step } = Steps;

const validatePassword = (email) => (password) => {
	if (!password) return false;
	const rules = /servipag/.test(email)
		? [/[a-z]/, /[A-Z]/, /\d/, /\W/, /(.+){8,}/]
		: [/(.+){8,}/];
	return rules.every((re) => re.test(password));
};

const SignUp = ({ loading, error, step, email, prev, next }) => {
	return (
		<Onboarding>
			<div>
				<h3>
					Regístrate en <span>ZeroQ</span>
				</h3>
				<Spacer rows={1} />
				<Steps current={step}>
					<Step />
					<Step />
					<Step />
				</Steps>
				<Spacer rows={1} />
				{step === 0 && <Step1 onSubmit={next} />}
				{step === 1 && (
					<Step2
						onSubmit={next}
						onPrev={prev}
						error={error}
						email={email}
						loading={loading}
					/>
				)}
				{step === 2 && <Step3 />}
			</div>
			<div>
				<h2>¿Ya tienes una cuenta?</h2>
				<p>No pierdas más tiempo e ingresa.</p>
				<Link to="/signin">
					<LoginButton label="Ingresar" />
				</Link>
			</div>
		</Onboarding>
	);
};

export default SignUpProvider(SignUp);

const Step1 = ({ onSubmit }) => {
	const [inputs, setInputs] = useState({});
	const [error, setError] = useState(null);

	const handleChange = ({ target: { name, value } }) => {
		setError(null);
		setInputs({
			...inputs,
			[name]: name === "email" ? value.toLowerCase() : value,
		});
		if (!validateEmail(name === "email" ? value : inputs.email)) {
			//setError("Mail inválido");
			return;
		}
	};

	const handleSubmit = () => {
		setError(null);
		if (!validateEmail(inputs.email)) {
			setError("Mail inválido");
			return;
		}
		onSubmit(inputs);
	};

	return (
		<>
			<Form>
				<Input
					validator={validateEmail}
					label="Correo electrónico"
					errorMessage="Mail inválido"
					name="email"
					value={inputs.email}
					onChange={handleChange}
				/>
				<Spacer rows={1} />
				{error && <ErrorMessage errors={error} />}
				<Spacer rows={1} />
			</Form>
			<NavButtons onNext={handleSubmit} />
		</>
	);
};

const Step2 = ({ email, onSubmit, error, onPrev, loading }) => {
	const [inputs, setInputs] = useState({});
	const [errors, setError] = useState([]);
	const validator = validatePassword(email);

	const handleChange = ({ target: { name, value, checked } }) => {
		setInputs({ ...inputs, [name]: checked || value });
	};

	const handleSubmit = () => {
		const errors = [];
		if (!validator(inputs.password)) {
			errors.push("Password inválido");
		}
		if (!inputs.terms) {
			errors.push("Debes aceptar los términos y condiciones");
		}
		if (errors.length > 0) {
			setError(errors);
			return;
		}
		onSubmit(inputs);
	};

	return (
		<>
			<Form>
				<Input
					validator={() => true}
					label="Nombre"
					name="name"
					value={inputs.name}
					onChange={handleChange}
				/>
				<Spacer rows={1} />
				<Password
					validator={validator}
					label="Contraseña"
					name="password"
					value={inputs.password}
					onChange={handleChange}
				/>
				<Spacer rows={1} />
				<PasswordLegend
					password={inputs.password}
					isNormalUser={!/servipag/.test(email)}
				/>
				<Spacer rows={2} />
				<Checkbox name="terms" onChange={handleChange}>
					Aceptar{" "}
					<Link to="/terms" target="_blank">
						{" "}
						términos y condiciones
					</Link>
				</Checkbox>
				<Spacer rows={1} />
				{(error || errors.length > 0) && (
					<ErrorMessage errors={error || errors} />
				)}

				<Spacer rows={1} />
				<NavButtons
					onPrev={onPrev}
					onNext={handleSubmit}
					loading={loading}
				/>
			</Form>
		</>
	);
};

const Step3 = () => {
	return (
		<div>
			<h3>Felicitaciones</h3>
			<p>
				Tu cuenta se ha creado exitosamente. Te redirigiremos a la
				página de inicio.
			</p>
		</div>
	);
};
